// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ConfigurationType, getProductByPath } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    SetConfigurationCompleted,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateConfigurationSelection";
import { ConfigurationModel } from "@insite/client-framework/Types/ApiModels";
import {
    filterConfiguration,
    FilterConfigurationApiParameter,
} from "@store/Framework/Services/DynamicConfiguratorService";
import { addToChainBefore, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

const swapEmptyGuids = (obj: SafeDictionary<string>): SafeDictionary<string> => {
    const newObj = { ...obj };
    for (const key in newObj) {
        if (newObj[key] === "00000000-0000-0000-0000-000000000000") {
            newObj[key] = "";
        }
    }
    return newObj;
};

export const FilterConfiguration = createChainHandler("FilterConfiguration", chain, async props => {
    const productDetail = props.getState().pages.productDetails;
    const totalSelections = productDetail.configurationSelection
        ? Object.keys(productDetail.configurationSelection).length
        : 0;
    if (totalSelections > 0) {
        if (!props.getState().pages.productDetails.lastProductPath) {
            return;
        }
        await getProductByPath({ path: props.getState().pages.productDetails.lastProductPath! }).then(async result => {
            if (
                !result.detail ||
                !result.detail.configuration ||
                result.configurationType !== ConfigurationType.Standard
            ) {
                return;
            }
            const payload = {
                KitId: result.productNumber,
                CurrentBtu: "0",
                MaxBtu: "0",
                Voltage: "",
                ConfigurationSelection: props.configurationSelection,
            } as FilterConfigurationApiParameter;
            const filteredConfiguration = await filterConfiguration(payload);
            if (!filteredConfiguration.successful) {
                throw new Error(filteredConfiguration.errorMessage);
            }
            result.detail.configuration = filteredConfiguration.result.configuration as ConfigurationModel;
            props.dispatch({
                type: "Data/Products/CompleteLoadProduct",
                model: result,
            });
            props.dispatch({
                type: "Store/Data/FilteredConfigurable/SetFilteredConfigurable",
                filteredConfigurable: {
                    id: result.id,
                    maxBtu: filteredConfiguration.result.maxBtu,
                    currentBtu: filteredConfiguration.result.currentBtu,
                    voltage: filteredConfiguration.result.voltage,
                    availability: filteredConfiguration.result.availability,
                },
            });
            if (filteredConfiguration.result.configurationSelection) {
                props.configurationSelection = swapEmptyGuids(filteredConfiguration.result.configurationSelection);
            }
        });
    }
});

addToChainBefore(chain, SetConfigurationCompleted, FilterConfiguration);
